import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import { useGetProductReportDetail } from "../../hooks/productreport.hook";
import { CustomTable } from "../../../../../components";
import { moneyFormat } from "../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../plugins/utils";

const ReportDetail = ({
  settledAt = null,
  gameId = null,
  categoryId = null,
}) => {
  const { t } = useTranslation();

  const [localData, setLocalData] = useState([]);
  const nowCurrency = getCurrency();

  const {
    data: productDetail,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
  } = useGetProductReportDetail({
    options: {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
    params: {
      settled_at: dayjs(settledAt).format("YYYY-MM-DD 00:00:00"),
    },
    categoryId: categoryId,
    gameId: gameId,
  });
  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (productDetail) {
      const page_length = productDetail.pages.length;
      if (page_length <= 1) {
        setLocalData([...productDetail.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...productDetail.pages[page_length - 1].data];
        });
      }
    }
  }, [productDetail]);

  const columns = [
    {
      title: t("normal.account"),
      dataIndex: "account",
      width: 170,
      align: "center",
    },
    {
      title: t("normal.uid"),
      dataIndex: "account_id",
      width: 100,
      align: "center",
    },
    {
      title: t("mobile.productReport.totalChurn", {
        currency: t(`global.currency.${nowCurrency}`),
      }),
      dataIndex: "total_bet_amount",
      search: false,
      render: (_, record) => (
        <span>{moneyFormat(record.total_bet_amount)}</span>
      ),
      width: 130,
      align: "center",
    },
    {
      title: t("mobile.productReport.winlost", {
        currency: t(`global.currency.${nowCurrency}`),
      }),
      dataIndex: "total_win_loss_amount",
      search: false,
      render: (_, record) => (
        <span
          style={{
            color:
              record?.total_win_loss_amount >= 0
                ? "var(--adm-color-success)"
                : "var(--adm-color-danger)",
          }}
        >
          {moneyFormat(record.total_win_loss_amount)}
        </span>
      ),
      width: 130,
      align: "center",
    },
  ];
  return (
    <div>
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default ReportDetail;
